import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
import AdminProducts from './AdminProducts';
import AdminIncomes from './AdminIncomes';
import AdminPurchases from './AdminPurchases';
import AdminRanks from './AdminRanks';
import AdminPayouts from './AdminPayouts';
import AdminFundTransfer from './AdminFundTransfer';
import AdminReports from './AdminReports';
import AdminPaymentHistory from './AdminPaymentHistory';
import AdminUserPayouts from './AdminUserPayouts';
import AdminMainDepositTransfers from './AdminMainDepositTransfers';
import AdminFundTransfers from './AdminFundTransfers';
import AdminInvestmentPlans from './AdminInvestmentPlans';
import AdminLifetimeRewards from './AdminLifetimeRewards';

const AdminLayout = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    const tabByPath = {
      '/admin': 'dashboard',
      '/admin/users': 'users',
      '/admin/products': 'products',
      '/admin/payouts': 'payouts',
      '/admin/reports': 'reports',
      '/admin/payment-history': 'payment-history',
      '/admin/fund-transfers': 'fund-transfers',
      '/admin/investment-plans': 'investment-plans',
      '/admin/lifetime-rewards': 'lifetime-rewards'
    };

    if (tabByPath[location.pathname]) {
      setActiveTab(tabByPath[location.pathname]);
    }
  }, [location.pathname]);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'users':
        return <AdminUsers />;
      case 'products':
        return <AdminProducts />;
      case 'incomes':
        return <AdminIncomes />;
      case 'purchases':
        return <AdminPurchases />;
      case 'ranks':
        return <AdminRanks />;
      case 'payouts':
        return <AdminPayouts />;
      case 'payment-history':
        return <AdminPaymentHistory />;
      case 'fund-transfer':
        return <AdminFundTransfer />;
      case 'reports':
        return <AdminReports />;
      case 'user-payouts':
        return <AdminUserPayouts />;
      case 'main-deposit-transfers':
        return <AdminMainDepositTransfers />;
      case 'fund-transfers':
        return <AdminFundTransfers />;
      case 'investment-plans':
        return <AdminInvestmentPlans />;
      case 'lifetime-rewards':
        return <AdminLifetimeRewards />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex overflow-hidden">
      {/* Sidebar - Fixed position on desktop */}
      <AdminSidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
      />

      {/* Main Section - Independent scrolling */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        {/* Top Header - Fixed */}
        <div className="bg-white shadow-sm border-b border-gray-200 px-4 sm:px-6 py-4 flex-shrink-0">
          <div className="flex justify-between items-center">
            <h1 className="text-lg sm:text-xl font-bold text-[#0F2F3D] capitalize">
              {activeTab}
            </h1>

            <div className="flex items-center space-x-2 sm:space-x-4">
              <div className="text-xs sm:text-sm text-gray-500 hidden sm:block">
                Admin Panel
              </div>

              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-gradient-to-r from-[#E4572E] to-[#F47C4D] text-white flex items-center justify-center font-bold text-sm sm:text-base">
                A
              </div>
            </div>
          </div>
        </div>

        {/* Page Content - Scrollable */}
        <div className="flex-1 overflow-y-auto">
          <div className="px-4 sm:px-6 py-4 sm:py-6">
            <div className="max-w-7xl mx-auto">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;